import { FirstClassDocument, JobType, YouTubeEnhancedTranscriptStatus } from '../../../../types';
import background from '../../../portalGates/toBackground';
import { StateUpdateOptionsWithoutEventName } from '../../../types';
import { queueJob } from '../jobs';
import { updateDocument } from './update';

export const toggleVideoOriginalTranscript = async (
  documentId: string,
  options: StateUpdateOptionsWithoutEventName,
): Promise<void> => {
  let needsToTriggerEnhanceYouTubeTranscriptJob = false;

  await updateDocument(
    documentId,
    (doc) => {
      if (!doc?.source_specific_data) {
        doc.source_specific_data = {};
      }

      if (!doc?.source_specific_data?.video) {
        doc.source_specific_data.video = {};
      }

      const willShowEnhancedYoutubeTranscript =
        !doc.source_specific_data.video.show_enhanced_youtube_transcript;

      doc.source_specific_data.video.show_enhanced_youtube_transcript =
        willShowEnhancedYoutubeTranscript;

      if (
        willShowEnhancedYoutubeTranscript &&
        !doc.source_specific_data.video.enhanced_youtube_transcript_status
      ) {
        needsToTriggerEnhanceYouTubeTranscriptJob = true;
        doc.source_specific_data.video.enhanced_youtube_transcript_status = YouTubeEnhancedTranscriptStatus.Pending;
      }
    },
    { ...options, eventName: 'video-original-transcript-toggled' },
  );

  if (!needsToTriggerEnhanceYouTubeTranscriptJob) {
    return;
  }

  queueJob({
    jobType: JobType.EnhanceYouTubeTranscript,
    jobArguments: { documentId },
    options: { ...options },
  });

  background.pollLatestState(40);
};

export const setVideoEnhancedTranscriptStatus = async (
  documentId: string,
  status: YouTubeEnhancedTranscriptStatus,
  options: StateUpdateOptionsWithoutEventName,
): Promise<void> => {
  await updateDocument(
    documentId,
    (doc) => {
      if (!doc?.source_specific_data) {
        doc.source_specific_data = {};
      }

      if (!doc.source_specific_data.video) {
        doc.source_specific_data.video = {};
      }

      doc.source_specific_data.video.enhanced_youtube_transcript_status = status;
    },
    { ...options, eventName: 'video-enhanced-transcript-status-set' },
  );
};

export const reparseUserYoutubeDocumentIfNeeded = async (
  documentId: string,
  sourceSpecificData: FirstClassDocument['source_specific_data'],
  options: StateUpdateOptionsWithoutEventName,
): Promise<void> => {
  if (!sourceSpecificData?.video || sourceSpecificData.video?.caption_languages) {
    return;
  }

  queueJob({
    jobType: JobType.ReparseUserYoutubeDocument,
    jobArguments: { documentId },
    options: { ...options },
  });

  background.pollLatestState(40);
};
